module.exports = __webpack_public_path__ + "static/tcdd-basari-hikayesi-08b312b030f38c0f993224ed805e4b23.png";